/** @format */
import { ArrowRightIcon } from "@heroicons/react/solid";
import React from "react";
import "./Navbar.css";

export default function Navbar() {
  return (
    <header id="nav" className="bg-gray-800 md:sticky top-0 ">
      <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
        <a className="title-font font-medium text-white mb-4 md:mb-0">
          <a href="#about" className="ml-3 text-xl">
            Christian Thorn
          </a>
        </a>
        <nav className="md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-700	flex flex-wrap items-center text-base justify-center">
          <a href="#projects" id="navlinks" className="mr-5 hover:text-white">
            Past Work
          </a>
          <a href="#skills" id="navlinks" className="mr-5 hover:text-white">
            Skills
          </a>
          <a
            href="#testimonials"
            id="navlinks"
            className="mr-5 hover:text-white"
          >
            Testimonials
          </a>
        </nav>
        <a
          href="#contact"
          id="navlinks"
          className="inline-flex items-center bg-gray-800 border-0 py-1 px-3 focus:outline-none hover:bg-gray-700 rounded text-base mt-4 md:mt-0"
        >
          Hire Me
          <ArrowRightIcon id="navlinks" className="w-4 h-4 ml-1" />
        </a>
      </div>
    </header>
  );
}



// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js